import { FiClock, FiUser, FiChevronRight } from 'react-icons/fi'
import './TaskList.css'

const TaskList = ({ tasks, compact = false }) => {
  if (!tasks || tasks.length === 0) {
    return (
      <div className="task-list-empty">
        <div className="empty-icon">📋</div>
        <p>No tasks yet</p>
      </div>
    )
  }

  const statusConfig = {
    pending: { color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.1)', label: 'Pending' },
    in_progress: { color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.1)', label: 'In Progress' },
    completed: { color: '#10b981', bg: 'rgba(16, 185, 129, 0.1)', label: 'Completed' },
    blocked: { color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', label: 'Blocked' },
    cancelled: { color: '#64748b', bg: 'rgba(100, 116, 139, 0.1)', label: 'Cancelled' }
  }

  const priorityConfig = {
    p0: { label: 'Critical', color: '#ef4444' },
    p1: { label: 'High', color: '#f59e0b' },
    p2: { label: 'Medium', color: '#3b82f6' },
    p3: { label: 'Low', color: '#64748b' }
  }

  return (
    <div className={`task-list ${compact ? 'task-list-compact' : ''}`}>
      {tasks.map((task) => {
        const status = statusConfig[task.status] || statusConfig.pending
        const priority = priorityConfig[task.priority] || priorityConfig.p2

        return (
          <div key={task.task_id || task.id} className="task-list-item">
            <div className="task-list-left">
              <div className="task-status-dot" style={{ backgroundColor: status.color }} />
              <div className="task-list-info">
                <div className="task-list-title">{task.title}</div>
                {!compact && task.description && (
                  <div className="task-list-desc">{task.description}</div>
                )}
                <div className="task-list-meta">
                  {task.assigned_to && (
                    <span className="task-meta-item">
                      <FiUser size={12} />
                      {task.assigned_to}
                    </span>
                  )}
                  {task.due_date && (
                    <span className="task-meta-item">
                      <FiClock size={12} />
                      {new Date(task.due_date).toLocaleDateString()}
                    </span>
                  )}
                  <span
                    className="task-priority-badge"
                    style={{
                      color: priority.color,
                      borderColor: priority.color,
                      background: `${priority.color}15`
                    }}
                  >
                    {priority.label}
                  </span>
                  {!compact && (
                    <span
                      className="task-status-badge"
                      style={{
                        color: status.color,
                        borderColor: status.color,
                        background: status.bg
                      }}
                    >
                      {status.label}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="task-list-right">
              <FiChevronRight className="task-list-arrow" />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TaskList
